module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/40a2d492cde1a89028a00bdd8ea74c24.png";